import R from 'ramda';
/*
 transformAllProducts
 */
const checkIfIsCommissionRates = R.compose(
  rates => rates.some(o => o.retailRate),
  R.propOr([], 'rates')
);

const checkIfIsNettRates = R.complement(checkIfIsCommissionRates);

const getCheckIfOfferIsNettOrCommissionFn = rateType => R.both(R.propEq('rate', 'rateAmount'), R.equals(rateType, 'nett') ? checkIfIsNettRates : checkIfIsCommissionRates);

const checkIfOfferIsDiscount = R.propEq('rate', 'discount');

const groupByFnForRateSetsOrExtras = object => {
  if (checkIfIsCommissionRates(object)) return 'commission';
  return 'nett';
};

const groupByFnForOffers = offer => {
  if (checkIfOfferIsDiscount(offer)) return 'discount';
  if (getCheckIfOfferIsNettOrCommissionFn('nett')(offer)) return 'nett';
  if (getCheckIfOfferIsNettOrCommissionFn('commission')(offer)) return 'commission';
  return 'free';
};

const calCommission = (rateSetOfferExtra) => {
  if (R.prop('commissionPercentage', rateSetOfferExtra)) return R.prop('commissionPercentage', rateSetOfferExtra);
  const anyRateDetail = R.find((rate) => R.prop('retailRate', rate))(R.prop('rates', rateSetOfferExtra));
  const retailRate = R.propOr(0, 'retailRate', anyRateDetail);
  const nettRate = R.propOr(0, 'nettRate', anyRateDetail);
  return Math.round((retailRate - nettRate) * 100 / retailRate);
};

const calSetCommissionIfNotExists = rateSetOfferExtra => {
  if (checkIfIsCommissionRates(rateSetOfferExtra)) {
    return R.merge(rateSetOfferExtra, {
      commissionPercentage: calCommission(rateSetOfferExtra),
    })
  }
  return rateSetOfferExtra;
};

const groupByForOffersOrExtras = updateType => R.compose(
  R.groupBy(R.equals(updateType, 'offers') ? groupByFnForOffers : groupByFnForRateSetsOrExtras),
  R.map(calSetCommissionIfNotExists),
  R.propOr([], updateType)
);

const mapForSeasonRate = seasonRate => R.merge(seasonRate, {
  rateSets: R.compose(
    R.groupBy(groupByFnForRateSetsOrExtras),
    R.map(calSetCommissionIfNotExists),
    R.propOr([], 'rateSets')
  )(seasonRate)
});


const transformUpdateType = R.curry((updateType, product) => R.merge(product, {
  [updateType]: R.equals(updateType, 'seasonRates') ? R.map(mapForSeasonRate, R.propOr([], 'seasonRates')(product)) : groupByForOffersOrExtras(updateType)(product)
}));

const transformAllProducts = updateType => R.map(transformUpdateType(updateType));

const transformAllKindsOfRates = allKindsOfRates => {
  const mapObjFn = (val, typeAsKey) => {
    const products = transformAllProducts(typeAsKey)(val);
    const subMenus = getAvailableSubMenu(typeAsKey)(products);
    return {
      products,
      subMenus,
      retailDiffForAll: '',
      nettDiffForAll: '',
      discountDiffForAll: '',
      commissionForAll: '',
      nettMeasure: 'dollar',
      commissionMeasure: 'dollar',
      discountMeasure: 'dollar',
    };
  };
  return R.mapObjIndexed(mapObjFn, allKindsOfRates);
};

/*
end transformAllProducts
 */
const checkIfProductWithNothingToShow = R.curry((updateType, rateType, product) => {
  if (R.equals(updateType, 'seasonRates')) {
    return R.all(R.compose(
      (rateTypeArray) => R.or(R.isEmpty(rateTypeArray), R.isNil(rateTypeArray)),
      R.prop(rateType),
      R.propOr({}, 'rateSets'),
    ))(R.propOr({}, 'seasonRates')(product));
  }
  return R.compose(
    (rateTypeArray) => R.or(R.isEmpty(rateTypeArray), R.isNil(rateTypeArray)),
    R.prop(rateType),
    R.propOr({}, updateType)
  )(product);
});
/*
 getAvailableSubMenu
 */
const getAvailableSubMenuForSeasonRates = R.compose(
  R.uniq,
  R.flatten,
  R.map(R.keys),
  R.map(R.propOr({}, 'rateSets')),
  R.flatten,
  R.map(R.propOr([], 'seasonRates'))
);

const getAvailableSubMenuForExtrasOrOffers = updateType => R.compose(
  R.uniq,
  R.flatten,
  R.map(R.keys),
  R.map(R.propOr({}, updateType))
);
const getAvailableSubMenu = updateType => R.equals(updateType, 'seasonRates') ? getAvailableSubMenuForSeasonRates : getAvailableSubMenuForExtrasOrOffers(updateType);
/*
 end getAvailableSubMenu
 */


/*
end udpate rates
 */

const repairAllProducts = (updateType, products) => R.map(product => R.merge(product, {
  [updateType]: R.equals(updateType, 'seasonRates') ? R.map(
    seasonRate => R.merge(seasonRate, {
        rateSets: R.compose(R.flatten, R.values, R.propOr({}, 'rateSets'))(seasonRate),
      }
    ),
    R.propOr([], 'seasonRates')(product)
  ) : R.compose(R.flatten, R.values, R.propOr({}, updateType))(product),
}))(products);

const existsAndNotEqualsToZero = key => R.compose(
  R.allPass([
    val => R.complement(R.isNil)(val),
    val => R.complement(R.equals(0))(val),
    val => R.complement(R.equals('0'))(val),
    val => R.complement(R.equals(''))(val),
  ]),
  R.prop(key)
);

const checkIfUpdatesExist = rateType => R.any(
  R.anyPass(R.cond([
    [R.equals('nett'), R.always([existsAndNotEqualsToZero('nettDiff')])],
    [R.equals('discount'), R.always([existsAndNotEqualsToZero('discountDiff')])],
    [R.equals('commission'), R.always([
      existsAndNotEqualsToZero('retailDiff'),
      existsAndNotEqualsToZero('commission'),
    ])],
    [R.T, R.always([
      existsAndNotEqualsToZero('nettDiff'),
      existsAndNotEqualsToZero('discountDiff'),
      existsAndNotEqualsToZero('retailDiff'),
      existsAndNotEqualsToZero('commission'),
    ])],
  ])(rateType))
);

export {
  transformAllKindsOfRates,
  checkIfProductWithNothingToShow,
  getAvailableSubMenu,
  repairAllProducts,
  checkIfUpdatesExist,
};



// WEBPACK FOOTER //
// ./src/app/utils/mass-rate-change-helpers.js